import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/work-orders/create-work-order')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/work-orders/create" />;
}
